export const LEADS_TYPES = {
  INCOMING: 'INCOMING',
  NEGOTIATION: 'NEGOTIATION',
  DECISION_MAKING: 'DECISION_MAKING',
  WIN: 'WIN',
  LOST: 'LOST'
};
export const LEADS_TYPES_LIST = [
  LEADS_TYPES.INCOMING,
  LEADS_TYPES.NEGOTIATION,
  LEADS_TYPES.DECISION_MAKING,
  LEADS_TYPES.WIN,
  LEADS_TYPES.LOST,
];
export const CLIENT_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
};
export const PAYMENT_TYPES = {
  INSURANCE_COMPANY: 'INSURANCE_COMPANY',
  TO_BROKER_AGENT: 'TO_BROKER_AGENT',
};
export const PAYMENT_FORMATS = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMIANNUALLY: 'SEMIANNUALLY',
  ANNUALLY: 'ANNUALLY',
};
export const PAYMENT_STATUSES = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
};
export const TRANSACTION_STATUSES = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
};
export const ACQUISITION_CHANNELS = {
  WEBSITE: 'WEBSITE',
  AGENT: 'AGENT',
  COLD_CALLING: 'COLD_CALLING',
  REFERRAL: 'REFERRAL',
  UNDEFINED: 'UNDEFINED',
};
// The dashboard metrics endpoint returns legacy enum channels by name, untranslated; DB-backed
// channels carry a free-text name that must be printed as the company typed it. Only this fixed
// set is translatable.
export const ACQUISITION_CHANNELS_TEXTS = {
  [ACQUISITION_CHANNELS.WEBSITE]: 'leads.options.Website',
  [ACQUISITION_CHANNELS.AGENT]: 'leads.options.Agent',
  [ACQUISITION_CHANNELS.COLD_CALLING]: 'leads.options.ColdCalling',
  [ACQUISITION_CHANNELS.REFERRAL]: 'leads.options.Referral',
  [ACQUISITION_CHANNELS.UNDEFINED]: 'leads.options.Undefined',
};
export const LEADS_TYPES_INFO = {
  [LEADS_TYPES.INCOMING]: {
    id: LEADS_TYPES.INCOMING,
    name: 'leads.Incoming',
    color: 'rgba(255, 189, 19, 1)',
    chartWidth: '169px'
  },
  [LEADS_TYPES.NEGOTIATION]: {
    id: LEADS_TYPES.NEGOTIATION,
    name: 'leads.Negotiation',
    color: 'rgba(173, 122, 255, 1)',
    chartWidth: '154px'
  },
  [LEADS_TYPES.DECISION_MAKING]: {
    id: LEADS_TYPES.DECISION_MAKING,
    name: 'leads.DecisionMaking',
    color: 'rgba(19, 128, 255, 1)',
    chartWidth: '140px'
  },
  [LEADS_TYPES.WIN]: {
    id: LEADS_TYPES.WIN,
    name: 'leads.Win',
    color: 'rgba(88, 219, 77, 1)',
    chartWidth: '127px'
  },
  [LEADS_TYPES.LOST]: {
    id: LEADS_TYPES.LOST,
    name: 'leads.Lost',
    color: 'rgba(255, 141, 122, 1)',
    chartWidth: '115px'
  },
};
export const LEADS_LIST = [
  LEADS_TYPES.INCOMING,
  // LEADS_TYPES.NEGOTIATION,
  // LEADS_TYPES.DECISION_MAKING,
  LEADS_TYPES.WIN,
  LEADS_TYPES.LOST,
];

export const PAYMENT_STATUSES_TEXTS = {
  [PAYMENT_STATUSES.PENDING]: 'leads.options.Pending',
  [PAYMENT_STATUSES.RECEIVED]: 'leads.options.Received',
};
export const TRANSACTION_STATUSES_TEXTS = {
  [TRANSACTION_STATUSES.PENDING]: 'leads.options.Pending',
  [TRANSACTION_STATUSES.RECEIVED]: 'leads.options.Received',
};

export const TASK_TYPES = {
  WITH_TASKS: 'WITH_TASKS',
  WITHOUT_TASKS: 'WITHOUT_TASKS',
};

export const TASK_TYPES_TEXTS = {
  [TASK_TYPES.WITH_TASKS]: 'leads.options.WithTasks',
  [TASK_TYPES.WITHOUT_TASKS]: 'leads.options.WithoutTasks',
};
export const LEADS_GROUPS_COLORS = [
  '#FFBD13',
  '#58DB4D',
  '#FF8D7A',
  '#AD7AFF',
  '#52A2FF',
  '#F9F35B',
  '#F95BF3',
  '#6FE1FB',
  '#2DADAD',
  '#6DA25F',
  '#404BAB',
];
export function getRandomColor() {
  return LEADS_GROUPS_COLORS[
    Math.floor(Math.random() * LEADS_GROUPS_COLORS.length)
  ];
}

export const ACTIVITY_TYPES = {
  EMAIL: 'EMAIL',
  CALL: 'CALL',
  MEETING: 'MEETING',
  TASK: 'TASK',
  WHATSAPP: 'WHATSAPP',
  SMS: 'SMS',
  CUSTOM: 'CUSTOM',
};

export const ACTIVITY_TYPES_LIST = [
  ACTIVITY_TYPES.EMAIL,
  ACTIVITY_TYPES.CALL,
  ACTIVITY_TYPES.MEETING,
  ACTIVITY_TYPES.TASK,
  ACTIVITY_TYPES.WHATSAPP,
  ACTIVITY_TYPES.SMS,
  ACTIVITY_TYPES.CUSTOM,
];

// TASK is deprecated: existing activities still render, but it can no longer be created.
export const ACTIVITY_TYPES_CREATABLE_LIST = ACTIVITY_TYPES_LIST.filter(
  (type) => type !== ACTIVITY_TYPES.TASK,
);

export const ACTIVITY_TYPES_INFO = {
  [ACTIVITY_TYPES.EMAIL]: {
    id: ACTIVITY_TYPES.EMAIL,
    name: 'activities.types.Email',
    icon: '/img/renova-dashboard/icons/mail.svg',
  },
  [ACTIVITY_TYPES.CALL]: {
    id: ACTIVITY_TYPES.CALL,
    name: 'activities.types.Call',
    icon: '/img/renova-dashboard/icons/phone-2.svg',
  },
  [ACTIVITY_TYPES.MEETING]: {
    id: ACTIVITY_TYPES.MEETING,
    name: 'activities.types.Meeting',
    icon: '/img/renova-dashboard/icons/calendar.svg',
  },
  [ACTIVITY_TYPES.TASK]: {
    id: ACTIVITY_TYPES.TASK,
    name: 'activities.types.Task',
    icon: '/img/renova-dashboard/icons/check-circle-grey.svg',
  },
  [ACTIVITY_TYPES.WHATSAPP]: {
    id: ACTIVITY_TYPES.WHATSAPP,
    name: 'activities.types.WhatsApp',
    icon: '/img/renova-dashboard/icons/whatsapp-grey.svg',
  },
  [ACTIVITY_TYPES.SMS]: {
    id: ACTIVITY_TYPES.SMS,
    name: 'activities.types.SMS',
    icon: '/img/renova-dashboard/icons/chat-send.svg',
  },
  [ACTIVITY_TYPES.CUSTOM]: {
    id: ACTIVITY_TYPES.CUSTOM,
    name: 'activities.types.Custom',
    icon: '/img/renova-dashboard/icons/edit-3.svg',
  },
};
